/**
 * ErrorAlert component displays data loading errors.
 *
 * @param {Object} props - Component props
 * @param {string} props.message - Error message to display
 * @param {Function} [props.onRetry] - Optional retry callback
 * @returns {React.ReactElement} Error alert
 */
export default function ErrorAlert({ message, onRetry }) {
  return (
    <div className="error-alert" role="alert">
      <div className="error-alert__icon" aria-hidden="true">
        ⚠️
      </div>
      <div className="error-alert__content">
        <h3 className="error-alert__title">Wystąpił błąd</h3>
        <p className="error-alert__message">{message}</p>
        {onRetry && (
          <button
            type="button"
            className="error-alert__retry"
            onClick={onRetry}
          >
            Spróbuj ponownie
          </button>
        )}
      </div>
    </div>
  )
}
